// /settings — на desktop redirect → /settings/profile;
// на mobile показывает iOS-list (рендерится SettingsShell в mobile-root mode).
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useIsLgUp } from "@/lib/platform-detect";

export const Route = createFileRoute("/settings/")({
	component: SettingsIndexRoute,
});

function SettingsIndexRoute() {
	const isDesktop = useIsLgUp();
	const navigate = useNavigate();

	useEffect(() => {
		if (isDesktop) {
			void navigate({ to: "/settings/profile", replace: true });
		}
	}, [isDesktop, navigate]);

	// На mobile shell сам отрисует список (см. SettingsShell mobile-root branch).
	// Возвращаем null, чтобы не ломать Outlet.
	return null;
}
